import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
import "../../components/new1.css";

const icon1 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";

const icon2 = "https://winpeforum.com/assets/elements/AparajitaAhuja.jpeg";

const icon3 = "https://winpeforum.com/assets/elements/MansiAggarwal.png";

const icon4 = "https://winpeforum.com/assets/elements/DianeJegam.jpg";

const icon5 = "https://winpeforum.com/assets/elements/PadmajaRuparel.jpg";
 
let duration = 400;

 
const I14 = "https://www.winpeforum.com/assets/sheshines/24jan2024/14.jpg";
const I15 = "https://www.winpeforum.com/assets/sheshines/24jan2024/15.jpg";
const I16 = "https://www.winpeforum.com/assets/sheshines/24jan2024/16.jpg";
const I17 = "https://www.winpeforum.com/assets/sheshines/24jan2024/17.jpg";
const I18 = "https://www.winpeforum.com/assets/sheshines/24jan2024/18.jpg";
const I19 = "https://www.winpeforum.com/assets/sheshines/24jan2024/19.jpg";
 
 
const II14 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/14.jpg";
const II15 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/15.jpg";
const II16 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/16.jpg";
const II17 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/17.jpg";
const II18 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/18.jpg";
const II19 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/19.jpg";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    
    this.Speaker1 = [
     
        {
            imgUrl: icon1,
            desc: `<div>
            Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ’s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy. In addition to her role managing the international offices, Ms. George contributes to diversifying the portfolio by taking a holistic view in approaching the various markets. She sits on CDPQ’s Investment-Risk Committee.<br/><br/>
        
        Ms. George joined CDPQ in April 2016 as Managing Director, South Asia. She was then appointed as Executive Vice-President, Growth Markets and prior to her current role was Executive Vice-President and Head of Strategic Partnerships, Growth Markets. She has extensive knowledge of several of these markets, in addition to possessing a strong ability to develop and strengthen enduring and quality partnerships.<br/><br/>
        
        She has a strong track record in managing infrastructure investment portfolios on a global scale. Prior to joining CDPQ, she was Senior Director of the World Bank’s Energy and Extractive Industries Global Practice. She also held the positions of Director, Infrastructure and Natural Resources of the International Finance Corporation, a member of the World Bank Group, and Head of Siemens Financial Services in India. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.<br/><br/>
        
        Ms. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.
        
                </div>`,
            name: "Anita George",
            post: `<div>Co-Founder<br/>
            Edhina Capital
            
            </div>`,
          },
         
          {
            imgUrl: icon2,
            desc: `<div>
            Aparajita is Partner and CFO at CX Partners, a leading Private Equity group in the Indian mid-market. Currently, she is on the Board of Betterplace. Previously she has served on the boards of DT Group, Veeda Clinical Research and TSI Pvt Ltd. She has been part of the vibrant Private Equity sector since 2008.<br/><br/>
        
            She is a qualified Chartered Accountant and holds an undergraduate degree in Commerce from the University of Delhi.
            
        
        
            </div>`,
            name: "Aparajita Ahuja",
            post: `<div>Partner & CFO<br/>CX Partners
        
        
            </div>`,
          },
        
         
        
          {
            imgUrl: icon4,
            desc: `<div>
            Diane Jegam is the Regional Director of Proparco South Asia, covering the origination of both debt and equity investments in the region. Since joining French Development Agency in 2008, Diane held different positions within the group with a focus in Africa and has worked in numerous impactful sectors.
            <br/><br/>
        Before this posting in India, she held the position of Deputy Director of the French Development Agency (AFD) in Dakar (2017 – 2021), one of the important office of AFD Group network.
        
        
        
            </div>`,
            name: "Diane Jegam",
            post: `<div>Regional Director South Asia	<br/>
            Proparco
            
            
            </div>`,
          },
          {
            imgUrl: icon3,
            desc: `<div>
            Mansi Aggarwal is a Partner at Alkemi Growth Capital. She has build and invest in leading and sustainable healthcare and consumer companies in India, with a portfolio of over 10 (and counting!) innovative and disruptive startups. With over 15+ years of experience as an investor, banker, and entrepreneur, she has a deep understanding of the opportunities and challenges in these sectors, and a passion for creating positive social impact.
    <br/><Br/>
    Her journey as a business leader began with her education in dental surgery and MBA, followed by involvement in the Stanford Biodesign program, where she co-founded and exited a medical device startup. She also hold 6 patents in healthcare and biotechnology and has been recognized for her achievements in Indian and global forums. She leverages her diverse background, skills, and network to support the growth and success of the companies she invest in and partner with.
      
            
            </div>`,
            name: "Mansi Aggarwal",
            post: `<div>Partner
    <br/>
            Alkemi Growth Capital
            
      
      
            </div>`,
          },
          {
            imgUrl: icon5,
            desc: `<div>
            Padmaja Ruparel is nationally recognized as a key player in the Indian entrepreneurial ecosystem and has helped co-found many of the relevant institutions, besides being an active Angel investor herself. Her operating experience spans large corporates, M&A, and startups/early stage companies. 
            <br/><br/>
        She has been awarded as one of the 'Top 50 Most Powerful Women in Business' by Fortune India for 2017, 2018 2019, listed in Forbes India's WPower Trailblazers and “30 Most Powerful Women in India” by Business Today for 3 years running. The Women Economic Forum recognized her with its “Women of the Decade in Investment Banking” award. 
        <br/><br/>
        She is Co-Founder & President of Indian Angel Network (IAN), India's first and now possibly one of the world's largest group of business angels, comprising the who's who of successful entrepreneurs and dynamic CEOs from India and overseas. She built IAN from inception, making it within 15 years a unique institution globally, with close to 500 investors across 10 countries and a portfolio of 175+ companies in 7 countries, spanning 17 sectors. She has operationalised IAN's international operations in London - making it the only angel group in the world to set up operations outside of its home country. Padmaja has been nominated as Co Chair of Global Business Angel Network (GBAN). She is a member of the National Expert Advisory Committee on Innovation, Incubation and Technology Entrepreneurship. She is a member of several committees of BIRAC (Dept. of Biotech, Govt. of India), various committees of the Ministry of Finance, DPIIT, & SEBI. 
        <br/><br/>
        Padmaja is the Senior Managing Partner of the IAN Fund, a uniquely differentiated Fund which along with IAN, is set to create the largest horizontal platform in India for investing in seed and early stage ventures. 
        <br/><br/>
        She is a member of the Governing Council of EM3 Services, a nation building venture seeking to create a paradigm shift in the Indian agricultural sector by improving productivity. Padmaja is an Independent Director on the Boards of Avendus Finance Pvt. Ltd. & Ester Industries Ltd. 
        <br/><br/>
        Apart from cofounding IAN, she also set up and operationalised the Delhi chapter of The Indus Entrepreneurs (TIE) the world's largest organization focused on entrepreneurship with over 16,000 members across more than 60 chapters across 14 countries. She also established a unique model of an incubator, in partnership with the Indian Government, leveraging 400 mentors to provide mentoring & domain expertise to around 50 young fledgling incubated companies. She played a key role as Executive Director in building the Indian Venture Capital Association, India's oldest and largest association of VC and PE firms. Currently, she is a member of IVCA's Limited Partners Council. 
        <br/><br/>
        She helped the creation of the Lankan Angel Network in Sri Lanka. She contributed actively in the Planning Commission's Committee on “Angel & Early Stage Investing in India” which resulted in a seminal report: “Creating a Vibrant Entrepreneurial Ecosystem in India”.
        <br/><br/>
        In her corporate avatar at Xansa India, (Xansa was a US$800mn company listed on LSE before being acquired by Steria), she led several functions over a 16 year period : handled recruitment operations, built and successfully executed an innovative brand and communication strategy and led the corporate social responsibility initiative which engaged employees, clients as also the government. She was a key member of the corporate strategy and M&A team as the Company went public, forged joint ventures and the final acquisition of the Indian company. 
        <br/><br/>
        Padmaja picked up entrepreneurial strings very early in her career - she revived and grew the family real estate business in Calcutta - growing from 50,000 sq ft to over 250,000 sq ft over 2 years and turned it around to become a profitable business. 
        <br/><br/>
        A graduate with English Honours, Padmaja then completed her MBA as well as Chartered Accountancy (Intermediate) with her internship with S.R. Batliboi (an E&Y group company).
        
        
        
            </div>`,
            name: "Padmaja Ruparel",
            post: `<div>Co-Founder & President<br/>
            Indian Angel Network
            
            
            </div>`,
          },
    ];
    this.CollegiumsImages = [
      { id:45, ImgSrc: I14, ImgSrc1: II14,},   
        { id:19, ImgSrc: I15, ImgSrc1: II15,},   
        { id:49, ImgSrc: I16, ImgSrc1: II16,},  

        { id:21, ImgSrc: I17, ImgSrc1: II17,},    
        { id:20, ImgSrc: I18, ImgSrc1: II18,},  
        { id:14, ImgSrc: I19, ImgSrc1: II19,},   

        
      
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Women on Boards"
          image={"https://winpeforum.com/assets/wob/banner.jpg"}
          description="Winpe’s Women on Boards initiative partners with progressive companies to build stronger, more diverse boardrooms by increasing the representation of highly qualified, board-ready women leaders. The initiative provides access to a curated pool of exceptional candidates, board-readiness resources, and engagement models that align with companies’ governance goals and DEI commitments."
          location={location} 
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper" style={{paddingTop:'110px', minHeight:'auto'}}>
            
            <div className="toastshine_section">
         <a href="https://tally.so/r/wv9OJX">   <img className="main-img-1" src="https://winpeforum.com/assets/wob/banner1.jpg" alt="About Image" style={{width:'100%'}}/></a>
               </div> </div>
           


<div style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg.jpg)', height:'auto',  width:'100%',  backgroundSize:'cover'}}>
    <div className="container"><br/><br/> 
  
<h1 className=" title" style={{color:'#ffffff', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'600',fontFamily:'Lato'}}>
About WOB </h1>
<div className="sub__body__text" style={{ textAlign: 'center', color:'#ffffff', fontSize:'17px'}}> Winpe is a leading platform committed to advancing gender diversity and leadership representation in the investing ecosystem. Winpe collaborates closely with Private Equity and Venture Capital firms, as well as broader industry stakeholders, to foster a more inclusive and equitable environment for women professionals across levels and functions.<br/><br/>

Winpe’s Women on Boards initiative partners with progressive PEVC firms and companies to build stronger, more diverse boardrooms by increasing the representation of highly qualified, experienced women leaders. The initiative provides access to a curated pool of exceptional candidates, boardroom excellence resources, and builds a strong peer community of women on boards.<br/><br/>
For queries, Please reach out to us on wob@winpeforum.com.
</div>
<br/><br/>
    </div>
</div> 



<div style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg2.png)', height:'auto',  width:'100%',  backgroundSize:'cover'}}>
    <div className="container"><br/><br/> 
 <div className="col-md-4">
  <h1 className=" title" style={{color:'#22316b', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'600',fontFamily:'Lato'}}>
18% </h1>

<div className="sub__body__text" style={{ textAlign: 'center', color:'#000', fontSize:'17px'}}> Women on Indian Boards (2022) 
</div>
 
  </div>  
 
 <div className="col-md-4">
  <h1 className=" title" style={{color:'#bf2026', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'600',fontFamily:'Lato'}}>
600+ </h1>

<div className="sub__body__text" style={{ textAlign: 'center', color:'#000', fontSize:'17px'}}> Companies with only 1 Woman Director 
</div>
 
  </div>  
 
 <div className="col-md-4">
  <h1 className=" title" style={{color:'#22316b', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'600',fontFamily:'Lato'}}>
1% </h1>

<div className="sub__body__text" style={{ textAlign: 'center', color:'#000', fontSize:'17px'}}> Growth in 3 years
 
</div>
 
  </div>  
 

<br/>

<div className="sub__body__text" style={{ textAlign: 'center', color:'#000', fontSize:'9px', fontWeight:'500'}}> 
  <br/><br/><br/><br/>  <br/><br/>
  *EY Report- <a href="https://www.ey.com/en_in/women-fast-forward/accelerate-dei-in-the-boardrooms-to-create-long-term-value-and-sustainability">https://www.ey.com/en_in/women-fast-forward/accelerate-dei-in-the-boardrooms-to-create-long-term-value-and-sustainability</a>  <br/><br/> 
</div>

<br/>
<br/>

<h1   style={{color:'#22316B', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'700', fontFamily:'Lato'}}>
Impact of Gender Diverse Boards on Business Performance</h1>
<marquee style={{fontSize:'17px'}}><b>Profit Margins:</b> Firms with greater gender diversity in leadership reported up to 30% higher profit margins and nearly 30% higher cumulative ROE over five years.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Share Price Performance:</b> Companies with more than 50% female executives and directors averaged a 3-year annualized share price return of 13.46%, compared to 4.78% for less diverse companies.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>RoA:</b> A 2020 study of S&P 500 boards conducted over eleven years found a positive link between higher gender diversity and increased return on assets.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Revenue Growth:</b> S&P 500 companies with more than 30% female board representation outperformed those with less than 20% in year-over-year revenue growth, across 11 of the top 15 industries.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Fund Returns and Profitable Exits (Venture Capital):</b> A 10% increase in female partner hires led to a 1.5% annual increase in fund returns and 9.7% more profitable exits in venture capital firms. </marquee><br/> 
  <br/> 
  
    </div>
</div> 

 <div style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg3.png)', height:'auto', minHeight:'540px' , width:'100%',  backgroundSize:'cover', paddingBottom:'45px'}}>
    <div className="container"><br/><br/> 
    <br/>
<h1 className=" title" style={{color:'#22316b', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'700', fontFamily:'Lato'}}>
Our Approach
</h1>
  
<br/> 
        <div class="col-md-12">
        <div class="col-sm-6 col-md-4 col-lg-4"><br/><br/>
        <div className="box" style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg.jpg)', color:'#fff', width:'95%', padding:'25px 10px 20px 20px', minHeight:'200px', textAlign:'center'}}>
        <img src="https://winpeforum.com/assets/wob/1.png" style={{width:'60px'}}/>
        <h2 >Ecosystem Building</h2>
        <p>Access to board roles/ candidates, sessions on board excellence, regular knowledge updates and in-person networking with experts and peers</p>
        </div></div>
        <div class="col-sm-6 col-md-4 col-lg-4"><br/><br/>
        <div className="box" style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg.jpg)', color:'#fff', width:'95%', padding:'20px 10px 20px 20px', minHeight:'200px', textAlign:'center'}}>
       <img src="https://winpeforum.com/assets/wob/2.png" style={{ width:'70px'}}/>
        <h2>Industry Buy-In</h2>
        <p>Support from top tier PEVC firms keen to add expertise and diverse perspectives to the boards of their investee companies</p>
        </div></div>
        <div class="col-sm-6 col-md-4 col-lg-4"><br/><br/>
        <div className="box" style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg.jpg)', color:'#fff', width:'95%', padding:'25px 10px 20px 20px', minHeight:'240px', textAlign:'center'}}>
       <img src="https://winpeforum.com/assets/wob/3.png" style={{width:'50px'}} />
       <h2>Expertise Led </h2>
        <p>Curated database of senior women professionals with deep experience and expertise across sectors and functions</p>
        </div>
        </div>
        </div>

         <div class="col-md-12">
        <div class="col-sm-6 col-md-2 col-lg-2">&nbsp;</div>
        <div class="col-sm-6 col-md-4 col-lg-4"><br/><br/>
        <div className="box" style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg.jpg)', color:'#fff', width:'95%', padding:'25px 10px 20px 20px', minHeight:'230px', textAlign:'center'}}>
       <img src="https://winpeforum.com/assets/wob/4.png" style={{width:'60px'}}/>
        <h2>Pre-screening for fit</h2>
        <p>All profiles screened and catalogued based on a wide number of technical criteria to support best matching </p>
        </div></div>
        <div class="col-sm-6 col-md-4 col-lg-4"><br/><br/>
        <div className="box" style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg.jpg)', color:'#fff', width:'95%', padding:'25px 10px 20px 20px', minHeight:'230px', textAlign:'center'}}>
        <img src="https://winpeforum.com/assets/wob/5.png" style={{width:'60px'}}/>
        <h2>Complete Confidentiality</h2>
        <p>Strict confidentiality and anonymity of the companies and profiles in the database, unless waived</p>
        </div></div>
        </div>
</div>
</div> 

 <div style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg4.png)', height:'auto', minHeight:'540px' , width:'100%',  backgroundSize:'cover', paddingBottom:'45px'}}>
    <div className="container"><br/><br/> 
    <br/>
 
      
 
 <div className="col-sm-12 col-md-12 col-lg-12">
  
<h1 className=" title" style={{color:'#fff', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'700', fontFamily:'Lato'}}>
Board Excellence Session 
</h1>
  <br/><br/>
<center><img src="https://winpeforum.com/assets/wob/board1.png"/></center>
<br/><br/><br/>
<div className="sub__body__text" style={{ textAlign: 'center', color:'#fff', fontSize:'17px'}}>  
 

 Led by M. Damodaran, former Chairman of SEBI, UTI, and IDBI Bank along with board veterans, the Board Excellence session has been developed to elevate boardroom impact through India's most respected corporate governance expertise
<br/><br/>
Designed keeping in mind both first time directors and experienced directors, whether serving as independent directors, nominee directors or executive directors, the session uses a real-life lens to decode board room dynamics and functioning
</div>
<br/><br/>

 
         <div className="col-lg-4 col-md-4 col-sm-12" style={{margin:0, padding:0}}> 

           <img className="main-img-1" src="https://winpeforum.com/assets/wob/mod/b1.png" alt="About Image" style={{width:'100%' }}/>
            </div>
  <div className="col-lg-4 col-md-4 col-sm-12" style={{margin:0, padding:0}}>
           
          <a href="https://winpeforum.com/WOBShareholderMisalignment">  <img className="main-img-1" src="https://winpeforum.com/assets/wob/mod/a1new1.png" alt="About Image" style={{width:'100%' }}/>  
        </a>  </div>
           <div className="col-lg-4 col-md-4 col-sm-12" style={{margin:0, padding:0}}>
           
            <a href="https://winpeforum.com/WOBTheDPDPAct/">  <img className="main-img-1" src="https://winpeforum.com/assets/wob/mod/c1.png" alt="About Image" style={{width:'100%' }}/>  
        </a>    </div>


            <div className="col-lg-4 col-md-4 col-sm-12" style={{margin:0, padding:0}}>
           
            <a href="https://winpeforum.com/WOBSelf-Led-Series-Session1/">  <img className="main-img-1" src="https://winpeforum.com/assets/wob/mod/d1.png" alt="About Image" style={{width:'100%' }}/>  
        </a>    </div>
 
       
                 <div className="col-lg-4 col-md-4 col-sm-12" style={{margin:0, padding:0}}>
                  <a href="https://winpeforum.com/WOBModule2EventReport/">
              <img className="main-img-1" src="https://winpeforum.com/assets/wob/mod/e1.png" alt="About Image" style={{width:'100%' }}/> 
            </a></div>
              <div className="col-lg-4 col-md-4 col-sm-12" style={{margin:0, padding:0}}>
             <a href="https://winpeforum.com/WOBModule1EventReport/">   <img className="main-img-1" src="https://winpeforum.com/assets/wob/mod/f1.png" alt="About Image" style={{width:'100%' }}/> 
           </a> </div>
</div>
 </div>
</div> 
    
 
            

 <div   style={{backgroundImage:'url(https://winpeforum.com/assets/wob/bg2.png)', height:'auto', minHeight:'540px' , width:'100%',  backgroundSize:'cover', paddingBottom:'45px', paddingTop:'45px'}}>
            <div className="container">
              <br/><br/>
              <h1 className=" title" style={{color:'#22316b', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'700', fontFamily:'Lato'}}>
Distinguished Board of Advisors
</h1>
   <br/><br/>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <img className="main-img-1" src="https://winpeforum.com/assets/wob/speaker/4.png" alt="About Image" style={{width:'100%' }}/> 
            </div>
                 <div className="col-lg-3 col-md-3 col-sm-12">
              <img className="main-img-1" src="https://winpeforum.com/assets/wob/speaker/1.png" alt="About Image" style={{width:'100%' }}/> 
            </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
              <img className="main-img-1" src="https://winpeforum.com/assets/wob/speaker/2.png" alt="About Image" style={{width:'100%' }}/> 
            </div>
               <div className="col-lg-3 col-md-3 col-sm-12">
              <img className="main-img-1" src="https://winpeforum.com/assets/wob/speaker/3.png" alt="About Image" style={{width:'100%' }}/> 
            </div>
 <div className="col-md-12">
 <br/><br/> <br/><br/>
  <h1 className=" title" style={{color:'#22316b', textAlign:'center', marginTop:'0px',paddingLeft:'15px', fontWeight:'700', fontFamily:'Lato'}}>
Expert Screening Committee
</h1><br/><br/></div> 
  <div className="col-lg-4 col-md-4 col-sm-12">
             <center> <img className="main-img-1" src="https://winpeforum.com/assets/wob/speaker/5.png" alt="About Image" style={{width:'75%' }}/> </center>
            </div>
                 <div className="col-lg-4 col-md-4 col-sm-12">
            <center>   <img className="main-img-1" src="https://winpeforum.com/assets/wob/speaker/6.png" alt="About Image" style={{width:'75%' }}/> </center>
            </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
             <center>  <img className="main-img-1" src="https://winpeforum.com/assets/wob/speaker/7.png" alt="About Image" style={{width:'75%' }}/> </center>
            </div>
             

            </div>
</div>

      
 
       
     


{/* 
<div className="container " style={{paddingTop:'30px'}}>
            
        
            <h1 className=" title" style={{color:'#bf2026', textAlign:'left', fontWeight:'700'}}>
                
            Uncover <i>Premier Job</i> Opportunities
</h1><br/><br/>

            <div className="col-lg-4">
            <div  style={{backgroundColor:'#22316b', height:'290px', borderRadius:'30px'}} >
<div style={{ padding:'20px', fontFamily:'Lato', color:'#fff'}}>
<h3 style={{color:'#fff'}}>Vice President, Investments</h3>
  <p>
  <b style={{textAlign:'left'}}>Location:</b> Bangalore<br/><br/>

  <b style={{textAlign:'left'}}>Company:</b> Start-up venture capital firm focused on investing in young entrepreneurs to create global impact.<br/><br/></p>
  <button class="btn" style={{color:'#22316b', backgroundColor:'#fff',borderRadius:'20px', width:'100%'}}>View JD</button>
    </div>
<br/> <br/> 
 
            </div>
              </div>
             
              <div className="col-lg-4">
            <div  style={{backgroundColor:'#22316b', height:'290px', borderRadius:'30px'}} >
<div style={{ padding:'20px', fontFamily:'Lato', color:'#fff'}}>
<h3 style={{color:'#fff'}}>Vice President, Investments</h3>
  <p>
  <b style={{textAlign:'left'}}>Location:</b> Bangalore<br/><br/>

  <b style={{textAlign:'left'}}>Company:</b> Start-up venture capital firm focused on investing in young entrepreneurs to create global impact.<br/><br/></p>
  <button class="btn" style={{color:'#22316b', backgroundColor:'#fff',borderRadius:'20px', width:'100%'}}>View JD</button>
    </div>
<br/> <br/> 
 
            </div>
              </div>
              <div className="col-lg-4">
            <div  style={{backgroundColor:'#22316b', height:'290px', borderRadius:'30px'}} >
<div style={{ padding:'20px', fontFamily:'Lato', color:'#fff'}}>
<h3 style={{color:'#fff'}}>Vice President, Investments</h3>
  <p>
  <b style={{textAlign:'left'}}>Location:</b> Bangalore<br/><br/>

  <b style={{textAlign:'left'}}>Company:</b> Start-up venture capital firm focused on investing in young entrepreneurs to create global impact.<br/><br/></p>
  <button class="btn" style={{color:'#22316b', backgroundColor:'#fff',borderRadius:'20px', width:'100%'}}>View JD</button>
    </div>
<br/> <br/> 
 
            </div>
              </div>
              
            
          
         
             </div>
             <br/> <br/> */}

 

  
             <br/> <br/> 
     
            
             <div  >
 
 </div>
  

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
           
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/womenonboards/index.js